import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class ExtraChargesServices {

    // creating ExtraCharge

    createCharge = async (payload) => {
      const createExtraCharge = await Helpers.post({
        url: Constants.EXTRA_CHARGES,
        data: payload,
      });
      return createExtraCharge;
    }

    // update ExtraCharge

    updatCharge = async (payload) => {
      const updateExtraCharge = await Helpers.put({
        url: Constants.EXTRA_CHARGES,
        data: payload,
      });
      return updateExtraCharge;
    }

    // get ExtraCharge

    getCharges = async (orgId,entityName) => {
      let url = `${Constants.EXTRA_CHARGES}?`;
      if (orgId) url += `org_id=${orgId}&`;
      if (entityName) url += `entity_name=${entityName}&`;
      const ExtraCharges = await Helpers.get({ url });
      return ExtraCharges;
    }

    // delete ExtraCharge

    deleteCharge = async (payload) => {
      const deletedExtraCharge = await Helpers.delete({
        url: Constants.EXTRA_CHARGES,
        data: payload,
      });
      return deletedExtraCharge;
    }
}

export default new ExtraChargesServices();
